// @ts-nocheck
/* eslint-enable */
import React from 'react';

class DeferredHydration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldRerender: false,
    };
  }
  state;

  componentDidMount() {
    const { shouldDeferHydration } = this.props;
    if (this.root && shouldDeferHydration) {
      new IntersectionObserver(async ([entry], obs) => {
        if (!entry.isIntersecting) {
          return;
        }
        if (this.root) {
          obs.unobserve(this.root);
        }

        if (!this.state.shouldRerender) {
          this.setState({ shouldRerender: true });
        }
      }).observe(this.root);
    }
  }

  root = null;
  props;

  renderChildren() {
    return <div>{this.props.children}</div>;
  }

  renderWithRef() {
    return (
      <div
        ref={(c) => {
          this.root = c;
          if (this.root?.children?.length === 0 && !this.state.shouldRerender) {
            this.setState({ shouldRerender: true });
          }
        }}
        dangerouslySetInnerHTML={{ __html: '' }}
        suppressHydrationWarning
      />
    );
  }

  renderOnServer() {
    const props = this.props.name
      ? {
          id: `server-rendered-${this.props.name}`,
        }
      : {};
    return (
      <div {...props}>
        <div style={{ height: 0, visibility: 'hidden' }}>Rendered Server Side.</div>
        {this.props.children}
      </div>
    );
  }

  render() {
    const { shouldDeferHydration } = this.props;

    if (!shouldDeferHydration || this.state.shouldRerender) {
      return this.renderChildren();
    }

    if (typeof window !== 'undefined') {
      return this.renderWithRef();
    }

    return this.renderOnServer();
  }
}

DeferredHydration.defaultProps = {
  shouldDeferHydration: true,
  name: '',
};

export default DeferredHydration;
